export const isProduction = () =>
  !process.env.API_URL?.includes('gateway-test');
